module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_6-479b1697eff2211bb628c909db110708.jpg";